/**
 * Activities management screen (T12, frontend-map §1.5). ACTIVITIES-UI owns this file.
 *
 * Single-route master/detail (no `$activityId` route in Phase 1): the left pane lists
 * the caller's Activities + a "New Activity" action, the right pane edits the selected
 * one and manages its bundled Master Lists. The selected-activity id is local UI state
 * in the activities Zustand store (frontend-map §5), never a route param.
 */
import { ActivityEditor } from '@/components/activities/ActivityEditor';
import { ActivityList } from '@/components/activities/ActivityList';
import { useDocumentTitle } from '@/lib/useDocumentTitle';
import { useActivitiesUiStore } from '@/stores/activities';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/activities/')({
  component: ActivitiesIndex,
});

function ActivitiesIndex() {
  useDocumentTitle('Activities');
  const selectedActivityId = useActivitiesUiStore((s) => s.selectedActivityId);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold">Activities</h1>
        <p className="text-sm text-[var(--muted-foreground)]">
          Bundle Master Lists behind a "what are we doing?" prompt for one-tap selection.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-[minmax(16rem,22rem)_1fr]">
        <aside className="md:border-r md:border-[var(--border)] md:pr-6">
          <ActivityList />
        </aside>

        <section>
          {selectedActivityId ? (
            <ActivityEditor key={selectedActivityId} activityId={selectedActivityId} />
          ) : (
            <div className="flex min-h-40 items-center justify-center rounded-md border border-dashed border-[var(--border)] p-6">
              <p className="text-sm text-[var(--muted-foreground)]">
                Select an Activity to edit it, or create a new one.
              </p>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
